export default __webpack_public_path__ + "static/media/image-1.41ea8582.jpg";